import type { ReadonlyURLSearchParams } from 'next/navigation'
import { env } from '@/env/client'

export function getUrlWithParams(
  pathname: string,
  params: URLSearchParams | ReadonlyURLSearchParams,
) {
  const paramsString = params.toString()

  if (!paramsString) return pathname

  return `${pathname}?${paramsString}`
}

export function getAbsoluteUrl(path?: string) {
  if (!path) return env.NEXT_PUBLIC_BASE_URL

  // Return early, if path already is an absolute URL (http://, https://, ftp://, mailto:, etc.)
  if (/^([a-z][a-z\d+.-]*):\/\/|^(mailto|tel|sms):/i.test(path)) return path

  return path.startsWith('/')
    ? `${env.NEXT_PUBLIC_BASE_URL}${path}`
    : `${env.NEXT_PUBLIC_BASE_URL}/${path}`
}
